import React, { FC, useEffect, useState } from "react";
import { Button, InputField, SelectField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useAppraisalTempHook from "../../../hooks/useAppraisalTempHook";
import { MdCancel } from "react-icons/md";
import RatingBar from "../../forms/RatingBar";
export default ({ item, show }: any) => {
  var { control, handleSubmit, watch } = useForm();

  const { setLoading } = useStateSetter();
  const [questions, setquestions] = useState([]);
  const { SelectedOrg, config } = useStateGetter();
  const { getTempQuestions } = useAppraisalTempHook();

  const getquest = async () => {
    setLoading(true);
    try {
      var quest = await getTempQuestions(item.id);
      setquestions(quest);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getquest();
  }, []);

  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white min-w-[40vw] p-4  max-h-[90vh] overflow-y-scroll ">
          <div className="flex justify-between items-center my-2 ">
            <p className="font-semibold self-start   "> Preview</p>
            <MdCancel
              onClick={() => {
                show(false);
              }}
              size={20}
              className="text-gray-400 "
            />
          </div> 
          <p className="text-md font-semibold my-2  text-gray-600">
            {item.name}
          </p>
          <div>
            {questions.map((it: any, key: number) => (
              <div className="my-2">
                <span className="px-1 bg-textbg rounded text-xs  text-white ">
                  {key + 1}
                </span> 
                <span className=" text-gray-700 text-xs">{it.question}</span>
                <div className="mx-4">
                  {it.responseType == "ratings" && <RatingBar
                      name={`question${it.id}`}
                      title="Response"
                      placeholder={"Enter response"}
                      isDisabled={true}
                      control={control}
                      rules={{
                        required: " required",
                        pattern: {
                          value: textReg,
                          message: "Invalid",
                        }
                      }}/>
                      
                      }
                  {it.responseType == "text" && (
                    <InputField
                      name={`question${it.id}`}
                      title="Response"
                      placeholder={"Enter response"}
                      isDisabled={false}
                      control={control}
                      rules={{
                        required: " required",
                        pattern: {
                          value: textReg,
                          message: "Invalid",
                        },
                      }}
                    />
                  )}
                  {it.responseType == "options" && (
                    <SelectField
                      control={control}
                      name={`question${it.id}`}
                      rules={{ required: "required" }}
                      placeholder="Select"
                      title="Response"
                      options={it.options}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
